import { Container } from "react-bootstrap";
import { motion } from "framer-motion";

const SERVICES = [
    {
        icon: "💻",
        title: "Web Development",
        description:
            "End-to-end development of fast, modern, and accessible websites built to convert visitors into customers.",
        items: [
            "Custom React & Next.js Applications",
            "Responsive UI/UX Design",
            "E-commerce & Booking Systems",
            "Performance Optimisation",
            "API Integration & Backend (Node.js)",
        ],
    },
    {
        icon: "📈",
        title: "SEO & Content Strategy",
        description:
            "Data-driven search optimisation and content strategies that put your brand in front of the right audience at the right time.",
        items: [
            "Technical SEO Audits",
            "Keyword Research & Strategy",
            "On-page & Off-page Optimisation",
            "Google Analytics & Search Console",
            "Content Planning & Creation",
        ],
    },
    {
        icon: "📣",
        title: "Social Media & Digital Marketing",
        description:
            "Full-funnel digital marketing that builds brand awareness, grows your community, and drives real engagement.",
        items: [
            "Social Media Management (SMM)",
            "Brand Identity & Positioning",
            "Campaign Strategy & Execution",
            "Community Building",
            "Performance Reporting",
        ],
    },
];

const fadeUp = {
    hidden:  { opacity: 0, y: 28 },
    visible: (i = 0) => ({
        opacity: 1, y: 0,
        transition: { duration: 0.6, delay: i * 0.14, ease: [0.4, 0, 0.2, 1] },
    }),
};

export const Services = () => {
    return (
        <section className="services" id="services">
            <Container>
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-80px" }}
                >
                    <motion.span className="section-tag" variants={fadeUp} custom={0}
                        style={{ display: "flex", justifyContent: "center" }}>
                        What I Offer
                    </motion.span>
                    <motion.h2 variants={fadeUp} custom={1}>Services</motion.h2>
                    <motion.p className="section-subtitle" variants={fadeUp} custom={2}>
                        From pixel-perfect websites to search rankings and social growth —
                        I deliver end-to-end digital solutions that make your brand impossible to ignore.
                    </motion.p>

                    <motion.div
                        className="services-grid"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, margin: "-60px" }}
                    >
                        {SERVICES.map((svc, i) => (
                            <motion.div className="service-card" key={i} variants={fadeUp} custom={i} data-num={String(i + 1).padStart(2, '0')}>
                                <div className="service-icon">{svc.icon}</div>
                                <h3>{svc.title}</h3>
                                <p>{svc.description}</p>
                                <ul>
                                    {svc.items.map((item, j) => (
                                        <li key={j}>{item}</li>
                                    ))}
                                </ul>
                            </motion.div>
                        ))}
                    </motion.div>
                </motion.div>
            </Container>
        </section>
    );
};
